/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";

const HeartIcon = ({ stroke, fill, height, width, handleClick }) => {
    return (
        <div onClick={handleClick}>
            <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="12.5 11 21 18">
                <g>
                    <path
                        d="M33.5 16.8125C33.5 23.375 23.7697 28.6869 23.3553 28.9062C23.2461 28.965 23.124 28.9958 23 28.9958C22.876 28.9958 22.7539 28.965 22.6447 28.9062C22.2303 28.6869 12.5 23.375 12.5 16.8125C12.5017 15.2715 13.1147 13.794 14.2044 12.7044C15.294 11.6147 16.7715 11.0017 18.3125 11C20.2484 11 21.9434 11.8325 23 13.2397C24.0566 11.8325 25.7516 11 27.6875 11C29.2285 11.0017 30.706 11.6147 31.7956 12.7044C32.8853 13.794 33.4983 15.2715 33.5 16.8125Z"
                        fill={fill}
                    />
                    <path
                        d="M27.6875 11C25.7516 11 24.0566 11.8325 23 13.2397C21.9434 11.8325 20.2484 11 18.3125 11C16.7715 11.0017 15.294 11.6147 14.2044 12.7044C13.1147 13.794 12.5017 15.2715 12.5 16.8125C12.5 23.375 22.2303 28.6869 22.6447 28.9062C22.7539 28.965 22.876 28.9958 23 28.9958C23.124 28.9958 23.2461 28.965 23.3553 28.9062C23.7697 28.6869 33.5 23.375 33.5 16.8125C33.4983 15.2715 32.8853 13.794 31.7956 12.7044C30.706 11.6147 29.2285 11.0017 27.6875 11ZM23 27.3875C21.2881 26.39 14 21.8459 14 16.8125C14.0015 15.6692 14.4563 14.5732 15.2647 13.7647C16.0732 12.9563 17.1692 12.5015 18.3125 12.5C20.1359 12.5 21.6669 13.4713 22.3062 15.0312C22.3628 15.1688 22.4589 15.2865 22.5824 15.3693C22.7059 15.4521 22.8513 15.4963 23 15.4963C23.1487 15.4963 23.2941 15.4521 23.4176 15.3693C23.5411 15.2865 23.6372 15.1688 23.6937 15.0312C24.3331 13.4684 25.8641 12.5 27.6875 12.5C28.8308 12.5015 29.9268 12.9563 30.7353 13.7647C31.5437 14.5732 31.9985 15.6692 32 16.8125C32 21.8384 24.71 26.3891 23 27.3875Z"
                        fill={stroke}
                    />
                </g>
            </svg>
        </div>
    );
};

HeartIcon.propTypes = {
    stroke: PropTypes.string,
    fill: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    handleClick: PropTypes.func
};

export default HeartIcon;
